import tw, { styled } from 'twin.macro';

const TimerText = styled.h3(({ time }: { time: number }) => [
  tw`text-black`,
  time <= 10 && tw`text-danger-500`,
]);

export default TimerText;
